import React from 'react'
import { render } from 'react-dom'
import { Router, browserHistory, Route/*, IndexRedirect*/ } from 'react-router'

import registerServiceWorker from './registerServiceWorker'

// import Core from './core'
import Main from './main'

// import Errors from './errors'
// import ErrorItems from './errorItems'
import Service from './service'
// import Logs from './logs'
// import Sentry from './sentry'

render(
	<Router history={ browserHistory }>
		<Route component={Main} path="/">
			{/* <IndexRedirect to="/errors" /> */}
			{/* <Route component={Errors} path="errors" /> */}
			{/* <Route component={ErrorItems} path="errorItems/:serviceId" /> */}
			<Route component={Service} path="service/:serviceId" />
			{/* <Route component={Logs} path="logs" /> */}
			{/* <Route component={Sentry} path="sentry" /> */}
		</Route>
	</Router>, document.getElementById("root"));

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js